module.exports = __webpack_public_path__ + "static/media/question_zh.cfbd2cdf.png";